module.exports = __webpack_public_path__ + "img/MylesBrownMD.046e1e67.png";